import $api from "../http"
export default class PaysService {
    static getAllPayInMethods(){
        return $api.get("/payin_methods")
    }
    static getHistoryPayIn(){
        return $api.get("/getHistoryPayIn")
    }
    static getHistoryPayOut(){
        return $api.get("/getHistoryPayOut")
    }
}